import { ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { ComparisonService } from './services/comparison/comparison.service';
import { inject } from '@angular/core';
import { Deferred } from '@smarttask-common/src/lib/services/AngularSpecific/Deferred';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./area/home/home').then((x) => x.HomeComponent),
    },
    {
        path: 'pricing',
        loadComponent: () => import('./area/pricing/pricing').then((x) => x.PricingComponent),
    },
    {
        path: 'templates',
        loadChildren: () => import('./area/project-templates/templates.routes').then((m) => m.routes),
    },
    {
        path: 'blog',
        loadChildren: () => import('./area/blogs/blogs.routes').then((m) => m.routes),
    },
    {
        path: 'customer-stories',
        loadChildren: () => import('./area/customer-stories/customer-stories.routes').then((m) => m.routes),
    },
    {
        path: 'wall-of-love',
        loadComponent: () => import('./area/wall-of-love/wall-of-love').then((m) => m.WallOfLoveComponent),
    },
    {
        path: 'apps',
        loadChildren: () => import('./area/apps/apps.routes').then((m) => m.routes),
    },
    {
        path: 'features',
        loadChildren: () => import('./area/features/features.routes').then((m) => m.routes),
    },

    {
        path: 'uses/project-management',
        loadComponent: () => import('./area/use-cases/project-management/project-management').then((x) => x.ProjectManagementComponent),
    },
    {
        path: 'uses/resource-management',
        loadComponent: () => import('./area/use-cases/resource-management/resource-management').then((x) => x.ResourceManagementComponent),
    },
    {
        path: 'industry/marketing-agency',
        loadComponent: () => import('./area/teams/marketing-agency/marketing-agency').then((x) => x.MarketingAgencyComponent),
    },
    {
        path: 'industry/creative-agency',
        loadComponent: () => import('./area/teams/creative-agency/creative-agency').then((x) => x.CreativeAgencyComponent),
    },
    {
        path: 'industry/consultancy',
        loadComponent: () => import('./area/teams/consultancy/consultancy').then((x) => x.ConsultancyComponent),
    },
    {
        path: 'industry/software-service',
        loadComponent: () => import('./area/teams/software-service/software-service').then((x) => x.SoftwareServiceComponent),
    },
    {
        path: 'industry/architecture-and-engineering',
        loadComponent: () =>
            import('./area/teams/architecture-and-engineering/architecture-and-engineering').then((x) => x.ArchitectureAndEngineeringComponent),
    },
    {
        path: 'alternatives/:product_name',
        resolve: {
            details: comparisonResolver,
        },
        loadComponent: () => import('./area/product-comparison/product-comparison').then((x) => x.ProductComparisonComponent),
    },
    {
        path: 'legal',
        loadChildren: () => import('./area/legal/legal.routes').then((m) => m.routes),
    },

    {
        path: 'schedule-demo',
        loadComponent: () => import('./area/schedule-demo/schedule-demo').then((x) => x.ScheduleDemoPageComponent),
    },

    {
        path: 'error',
        loadComponent: () => import('../../../smarttask-common/src/lib/components/error/error').then((x) => x.ErrorComponent),
    },
    {
        path: 'not-found',
        loadComponent: () => import('../../../smarttask-common/src/lib/components/error/error').then((x) => x.ErrorComponent),
        data: { not_found: true },
    },
    {
        path: '**',
        loadComponent: () => import('../../../smarttask-common/src/lib/components/error/error').then((x) => x.ErrorComponent),
        data: { not_found: true },
    },
];

export async function comparisonResolver(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const comparisonService = inject(ComparisonService);
    const deferred = new Deferred<any>();

    let product_name = route.paramMap.get('product_name');

    try {
        if (product_name) {
            const details = await comparisonService.getDetails(product_name);
            deferred.resolve(details);
        } else {
            deferred.reject('Product name not found');
        }
    } catch (error) {
        deferred.reject(error);
    }
    return deferred.promise;
}
